var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp201({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.33c-3.49,0-6.33-2.84-6.33-6.33c0-3.49,2.84-6.33,6.33-6.33c3.49,0,6.33,2.84,6.33,6.33 C14.33,11.49,11.49,14.33,8,14.33z M8,2.17C4.78,2.17,2.17,4.78,2.17,8c0,3.22,2.62,5.83,5.83,5.83c3.22,0,5.83-2.62,5.83-5.83 C13.83,4.78,11.22,2.17,8,2.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.92,
    className: "st2",
    width: 0.5,
    height: 12.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.92,
    y: 7.75,
    className: "st2",
    width: 12.17,
    height: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp201);
export default __webpack_public_path__ + "static/media/Lamp2-01.cc74735614af07a924a51103284e0970.svg";
export { ForwardRef as ReactComponent };